let $itemClassName;
let $items;
let totalItems;
let slide = 0;
let $next = document.querySelector('.carousel__button--next');
let $prev = document.querySelector('.carousel__button--prev');
function initCarousel() {
    let carouseLibrary = {};
    $itemClassName = "carousel__item";
    $items = document.querySelectorAll('.' + $itemClassName);
    totalItems = $items.length;
    carouseLibrary.activeSlide = slide;
    if (totalItems === 1) {
        $items[0].classList.add("active");
    }
    if (totalItems > 1) {
        setInitialClasses();
        setEventListeners();
        $next.style.display = 'flex';
        $prev.style.display = 'flex';
    }
    carouseLibrary.on = function (Function) {
        $next.addEventListener('click', Function);
        $prev.addEventListener('click', Function);
    };
    return carouseLibrary;
}
function setInitialClasses() {
    $items[totalItems - 1].classList.add("prev");
    $items[0].classList.add("active");
    $items[1].classList.add("next");
}
function setEventListeners() {
    $next.addEventListener('click', moveNext);
    $prev.addEventListener('click', movePrev);
}
function moveNext() {
    if (slide === (totalItems - 1)) {
        slide = 0;
    }
    else {
        slide++;
    }
    moveCarouselTo(slide);
}
function movePrev() {
    if (slide === 0) {
        slide = (totalItems - 1);
    }
    else {
        slide--;
    }
    moveCarouselTo(slide);
}
function moveCarouselTo(slide) {
    if (slide < (totalItems - 1) && slide > 0) {
        console.log('move', $itemClassName);
        $items[slide - 1].className = $itemClassName + " prev";
        $items[slide].className = $itemClassName + " active";
        $items[slide + 1].className = $itemClassName + " next";
    }
    if (slide === (totalItems - 1)) {
        $items[slide - 1].className = $itemClassName + " prev";
        $items[slide].className = $itemClassName + " active";
        $items[0].className = $itemClassName + " next";
    }
    if (slide === 0) {
        $items[totalItems - 1].className = $itemClassName + " prev";
        $items[slide].className = $itemClassName + " active";
        $items[slide + 1].className = $itemClassName + " next";
    }
}
